import { render, staticRenderFns } from "./boxed.vue?vue&type=template&id=659f65a8&scoped=true&lang=pug"
import script from "./boxed.vue?vue&type=script&lang=js"
export * from "./boxed.vue?vue&type=script&lang=js"
import style0 from "./boxed.vue?vue&type=style&index=0&id=659f65a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659f65a8",
  null
  
)

export default component.exports